var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_960",
    "data-name": "Group 960",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.469,
    height: 24.467,
    viewBox: "0 0 24.469 24.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M20.5,7.99l1.1-2.4,2.4-1.1-2.4-1.1L20.5,1,19.4,3.4,17,4.5l2.4,1.1Z",
    transform: "translate(0.479 -1)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M9,7.99l1.1-2.4,2.4-1.1-2.4-1.1L9,1,7.9,3.4,5.5,4.5l2.4,1.1Z",
    transform: "translate(-1.419 -1)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M20.5,12.5l-1.1,2.4L17,16l2.4,1.1,1.1,2.4,1.1-2.4,2.4-1.1-2.4-1.1Z",
    transform: "translate(0.479 0.898)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M20.3,9.635l-3.3-3.3a1.182,1.182,0,0,0-1.654,0L2.338,19.352a1.16,1.16,0,0,0,0,1.643l3.3,3.3a1.156,1.156,0,0,0,.827.35A1.193,1.193,0,0,0,7.29,24.3L20.3,11.289A1.174,1.174,0,0,0,20.3,9.635Zm-4.124-.816,1.643,1.643-1.363,1.363-1.643-1.643ZM6.463,21.833,4.82,20.191l8.354-8.365,1.643,1.643Z",
    transform: "translate(-1.998 -0.175)",
    fill: "#FF6600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.186b207072e57bea42d10ba25d80200f.svg";
export { ForwardRef as ReactComponent };